import React from "react";
import { Link } from "react-router-dom";
import 'normalize.css';


export default function Login() {
  return (
    <main id="content" className="content">
      <section
        className="vc_row d-flex flex-wrap align-items-center justify-content-center bg-cover pt-150 pb-150"
        style={{ backgroundImage: "url(assets/demo/bg/bg-14.jpg)" }}
      >
        <div className="container">
          <div className="row">
            {/* Left side: Login form */}
            <div className="lqd-column col-md-6">
              <h2 className="text-white mb-30 text-center">Login to Your Account</h2>
              <form className="contact-form">
                <div className="form-group">
                  <label htmlFor="email" className="text-white">Email ID*</label>
                  <input
                    type="email"
                    id="email"
                    className="form-control"
                    placeholder="Enter your email"
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="password" className="text-white">Password*</label>
                  <input
                    type="password"
                    id="password"
                    className="form-control"
                    placeholder="Enter your password"
                    required
                  />
                </div>
                <button
                  type="submit"
                  className="btn btn-solid text-uppercase btn-md circle btn-bordered border-thin btn-gradient px-2"
                >
                  Login
                </button>
                <p className="text-white mt-3">
                  Don't have an account?{" "}
                 
                   <Link to="https://collectkart.docboyz.in/registration_user">
                      <span class="btn-txt">Register here</span>
                  </Link>
                </p>
              </form>
            </div>

            {/* Right side: Image */}
            <div className="lqd-column col-md-6 d-none d-md-block">
              <img
                src="assets/img/Login/LoginImg.jpg"
                alt="Login Visual"
                style={{ width: "100%", borderRadius: "8px" }}
              />
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
